<template>
    <div class="h-full min-h-screen bg-gray-100">
        <div class="container px-6">
            <div class="flex flex-wrap items-center justify-between py-6 mb-0 md:mb-6 md:py-10">
                <div class="flex flex-wrap items-center justify-between">
                  <router-link to="/">
                    <app-logo width="64px" />
                  </router-link>
                  <router-link to="/privacy-policy" class="px-6 font-semibold hover:text-blue-500">
                    Privaatsuspoliitika
                  </router-link>
                  <router-link to="/terms-of-use" class="px-6 font-semibold hover:text-blue-500">
                    Kasutustingimused
                  </router-link>
                  <a href="https://www.about.iffent.ee/kkk" class="px-6 font-semibold hover:text-blue-500">
                    Küsimused & Vastused
                  </a>
                </div>

                <div class="flex items-center justify-end">
                    <router-link
                        v-if="isAdmin"
                        to="/admin/dashboard"
                        class="inline-flex font-semibold hover:text-blue-500 px-6"
                    >Admin-liides
                    </router-link>

                    <router-link
                        to="/projects" class="inline-flex font-semibold hover:text-blue-500"
                    >Minu projektid
                    </router-link>

                    <button
                        type="button"
                        aria-haspopup="true"
                        aria-controls="profileMenu"
                        class="flex items-center justify-center w-10 h-10 ml-4 overflow-hidden bg-white rounded-full sm:ml-6"
                        @click="toggleProfileMenu"
                    >
                        <!-- IF HAS USER PHOTO: -->
                        <img v-if="false" src="https://joeschmoe.io/api/v1/1" />
                        <!-- ELSE: -->
                        <svg class="w-6 h-6 text-blue-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 22">
                            <path
                                fill="currentColor"
                                d="M14.4 4.8a4.8 4.8 0 11-9.6 0 4.8 4.8 0 019.6 0zM9.6 21.6a10.79 10.79 0 01-8.983-4.802c2.004-3 5.375-4.801 8.983-4.798 3.744 0 7.044 1.908 8.982 4.8A10.79 10.79 0 019.6 21.6z"
                            />
                        </svg>
                    </button>
                    <Menu id="profileMenu" ref="profileMenu" :model="profileMenu" popup />
                </div>
            </div>

            <transition appear name="fade" mode="out-in">
                <div key="pageSlot">
                    <slot />
                </div>
            </transition>
        </div>

        <toast position="top-center" />

        <cookie-accept/>
        <Dialog :visible.sync="showDialog" :closable="false" :closeOnEscape="false" modal class="w-2/3">
          <updates/>
        </Dialog>
    </div>
</template>

<script>
import AuthService from '../services/auth.service';
import CookieAccept from "@/components/CookieAccept";
import { mapGetters } from 'vuex';
import Updates from './../components/Updates.vue';
import {logout} from "@/store/login.api";

export default {
    components: {
      CookieAccept,
      Updates
    },
    computed: {
        ...mapGetters({
            user: 'global/user',
            isAdmin: 'global/isAdmin',
        }),
        showDialog() {
          return this.user.seenUpdates === false;
        }
    },
    data() {
        return {
            profileMenu: [
                {
                    label: 'Profiil',
                    icon: 'pi pi-user',
                    command: () => {
                        this.$router.push('/profile');
                    },
                },
                {
                    label: 'Logi välja',
                    icon: 'pi pi-sign-out',
                    //url: '/logout',
                    command: async() => {
                        await logout().then(({data}) => {
                           if(data) {
                               AuthService.logout();
                               setTimeout(() => {
                                   this.$router.push('/');
                               }, 100);
                           }
                        });
                    },
                }
            ]
        }
    },

    methods: {
        toggleProfileMenu(event) {
            this.$refs.profileMenu.toggle(event)
        }
    }
}
</script>
